import angular from 'angular';

import TrainingBtnController from './trainingBtn/trainingBtnController';
import TrainingBtnDirective from './trainingBtn/trainingBtnDirective';

import TrainingQAndAController from './trainingQA/trainingQAndAController';
import TrainingQAndADirective from './trainingQA/trainingQAndADirective';


export default angular.module('app.notificationCenter.modal.directives', [])
    .controller('TrainingBtnController', TrainingBtnController)
    .controller('TrainingQAndAController', TrainingQAndAController)
    .directive('hpTrainingBtn', TrainingBtnDirective)
    .directive('hpTrainingQAndA', TrainingQAndADirective)
    .run(($templateCache) => {
        $templateCache.put('app/notificationCenter/modal/training/directives/trainingBtn/trainingBtn.html', require('./trainingBtn/trainingBtn.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/training/directives/trainingQA/trainingQAndA.html', require('./trainingQA/trainingQAndA.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/directives/index.js